import DynamicFieldsSerializer from '@linc-technologies/linced-common/serializers/dynamic-fields';
// Extends From
// Ember Imports
import { isPresent } from '@ember/utils';

export default class Enrolment extends DynamicFieldsSerializer {
  namespace = 'people';
  rootKeys = ['people', 'person'];

  normalize(modelClass, payload) {
    // If we have postCounts, transform them into a map rather than an array of objects.
    if (isPresent(payload.postCounts)) {
      let counts = {};
      for (let i = 0; i < payload.postCounts.length; i++) {
        let count = payload.postCounts[i];
        counts[count.type] = count.items || [];

        for (let j = 0; j < counts[count.type].length; j++) {
          counts[count.type][j].itemId = counts[count.type][j].id;
        }
      }
      payload.postCounts = counts;
    }

    return super.normalize(...arguments);
  }

  serialize() {
    let hash = super.serialize(...arguments);

    // If we have postCounts, transform them back from a map into an array of objects.
    if (isPresent(hash.postCounts)) {
      let counts = [];
      Object.keys(hash.postCounts).forEach(function (key) {
        let items = hash.postCounts[key];
        items.forEach(function (item) {
          item.id = item.itemId;
          delete item.itemId;
        });
        counts.push({
          type: key,
          items,
        });
      });
      hash.postCounts = counts;
    }

    return hash;
  }
}
